import React, { useState } from "react";
import '../Styles/components.css';
import './CardStyles/CardD.css';
import PopUp from "../PopUps/AddToCart_Popup/PopUp"
import { MdShoppingCart } from "react-icons/md";
const PopupLayout = [{
  des: "none",
  options: "block",
  additional: "none",
  specialInstructions: "block",
}];

const CardD = (props, { children, className, ...restProps }) => {
  const [openModal, setOpenModal] = useState(false);

  const Popup = () => {
    setOpenModal(true);

    // Disables Background Scrolling whilst the SideDrawer/Modal is open
    if (typeof window != 'undefined' && window.document) {
      document.body.style.overflow = 'hidden';
    }
  }

  const ClosePopup = () => {
    setOpenModal(false);

    // Disables Background Scrolling whilst the SideDrawer/Modal is open
    document.body.style.overflow = 'unset';
  }
  return (
    <div onClick={Popup} {...restProps} className={`theme-div CardD-div ${className}`} >
      <div className={`theme-div CardD-div-0`}>
        <div className={`theme-div CardD-div-1`}>
          <picture className={`theme-picture CardD-picture`}>
            <source className={`theme-source CardD-source`} type="image/webp" />
            <img className={`theme-img CardD-img`} alt="" src={props.img} />
          </picture>
        </div>
        <div className={`theme-div CardD-div-2`}>
          <span className={`theme-span CardD-span`} />
        </div>
        <div className={`theme-div CardD-div-3`}>
          <div className={`theme-div CardD-div-4`}>
            <div className={`theme-div CardD-div-5`}>

              <span className={`theme-span CardD-span-0`}>Rs.{props.price}</span>
            </div>
            <div className={`theme-div CardD-div-6`}>
              <div className={`theme-div CardD-div-7`}>
                <button className={`theme-button CardD-button`} type="button">
                 <p> Add To Cart <MdShoppingCart style={{ marginBottom: "-2%" }}></MdShoppingCart></p>
                </button>
              </div>
              <h2 className={`theme-h2 CardD-h2`} children={props.name} />
              <div className={`theme-div CardD-div-6`}>
                <p className={`theme-p CardD-p`} children={props.des} />
              </div>
              <p className={`theme-p CardD-p`} />
            </div>
          </div>
        </div>
      </div>
      {PopupLayout.map((display) => (
        <PopUp
          key={props.id}
          open={openModal}
          onClose={ClosePopup}
          name={props.name}
          id={props.id}
          price={props.price}
          discountedprice={props.discountedprice}
          des={props.des}
          img={props.img}
          displayDes={display.des}
          displayOption={display.options}
          displayAdditional={display.additional}
          displaySpecialInstruction={display.specialInstructions}
        />
      ))}
    </div>
  );
};
CardD.defaultProps = {
  name: "Name",
  price: "Price",
  img: "https://admin.indolj.io/upload/1673272416-WhatsApp%20Image%202023-01-09%20at%205.11.41%20PM-min.jpeg",
  des: "lorem ipsum + lorem ipsum + lorem ipsum + lorem ipsum"
}
export default CardD;
